import React, { useRef, useState } from 'react'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import ArrowDropDownIcon from 'components/material-symbol/icons/ArrowDropDown'
import AddTimeMenuItems from './add-time-menu-items'
import OneTimeSlotDialog from './one-time-slot-dialog'

const AddTimeMenu = ({
  facilities,
  onSuccess,
  compact,
  defaultFacilityId,
  existingOverrides,
}) => {
  const buttonRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [openTimeOpen, setOpenTimeOpen] = useState(false)
  const [blockedTimeOpen, setBlockedTimeOpen] = useState(false)

  const handleSelect = type => () => {
    setMenuOpen(false)
    if (type === 'open') setOpenTimeOpen(true)
    if (type === 'block') setBlockedTimeOpen(true)
  }

  return (
    <>
      {compact ? (
        <IconButton
          ref={buttonRef}
          color="primary"
          aria-label="Add time"
          title="Add time"
          onClick={() => setMenuOpen(true)}
        >
          <AddOutlinedIcon />
        </IconButton>
      ) : (
        <Button
          ref={buttonRef}
          variant="contained"
          color="primary"
          startIcon={<AddOutlinedIcon />}
          endIcon={<ArrowDropDownIcon />}
          style={{ whiteSpace: 'nowrap' }}
          onClick={() => setMenuOpen(true)}
        >
          Add Time
        </Button>
      )}
      <Menu
        anchorEl={buttonRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <AddTimeMenuItems
          onSelectOpen={handleSelect('open')}
          onSelectBlocked={handleSelect('block')}
        />
      </Menu>
      <OneTimeSlotDialog
        facilities={facilities}
        onSuccess={onSuccess}
        triggerless
        isOpen={openTimeOpen}
        onClose={() => setOpenTimeOpen(false)}
        initialType="open"
        defaultFacilityId={defaultFacilityId}
        existingOverrides={existingOverrides}
      />
      <OneTimeSlotDialog
        facilities={facilities}
        onSuccess={onSuccess}
        triggerless
        isOpen={blockedTimeOpen}
        onClose={() => setBlockedTimeOpen(false)}
        initialType="block"
        defaultFacilityId={defaultFacilityId}
      />
    </>
  )
}

export default AddTimeMenu
